import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Grid, Menu } from 'semantic-ui-react';

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <Container id='footer' fluid>
      <Container>
        <Grid>
          <Grid.Row columns={3}>
            <Grid.Column>
              <Menu text vertical fluid>
                <Menu.Item header>Explore the Project</Menu.Item>
                <Menu.Item as={Link} to='/'>Home</Menu.Item>
                <Menu.Item as={Link} to='/partnership'>NATS Partnership</Menu.Item>
                <Menu.Item as={Link} to='/about'>About Living Song Project</Menu.Item>
                <Menu.Item as={Link} to='/search'>Search</Menu.Item>
                <Menu.Item as={Link} to='/feedback'>Feedback</Menu.Item>
              </Menu>
            </Grid.Column>
            <Grid.Column>
              <Menu text vertical fluid>
                <Menu.Item header>Browse</Menu.Item>
                <Menu.Item as={Link} to='/composers'>Composers</Menu.Item>
                <Menu.Item as={Link} to='/text-authors'>Text Authors</Menu.Item>
                <Menu.Item as={Link} to='/song-cycles'>Song Cycles &amp; Collections</Menu.Item>
                <Menu.Item as={Link} to='/songs'>Songs</Menu.Item>
                <Menu.Item as={Link} to='/chamber-music'>Chamber Music</Menu.Item>
              </Menu>
            </Grid.Column>
            <Grid.Column>
              <Menu text vertical fluid>
                <Menu.Item header>Friends of Living Song Project</Menu.Item>
                <Menu.Item href='https://nats.org' target='_blank'>National Association of Teachers of Singing</Menu.Item>
                <Menu.Item href='https://www.ou.edu/' target='_blank'>University of Oklahoma</Menu.Item>
                <Menu.Item href='https://www.uc.edu/' target='_blank'>University of Cincinnati</Menu.Item>
                <Menu.Item href='https://www.ttu.edu' target='_blank'>Texas Tech University</Menu.Item>
              </Menu>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='center'>
              <small>Copyright &copy; {year} Living Song Project. All Rights Reserved.</small>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Container>
  );
};